import { PreloadingStrategy, Route } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, of, timer } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class CustomPreloadingStrategyService implements PreloadingStrategy {
    preload(route: Route, load: () => Observable<any>): Observable<any> {
        const loadRoute = (delay) => {
            return delay > 0
                ? timer(delay * 1000).pipe(
                      map(() => {
                          return load();
                      }),
                  )
                : load();
        };

        if (route.data && route.data.preload) {
            const delay = route.data.delay ? route.data.delay : 0;
            return loadRoute(delay);
        } else {
            return of(null);
        }
    }
}
